import UserStore from '../../../../stores/UserStore';

class CanPayCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            token: ''
        };

        this.doCheckout = this.doCheckout.bind(this);
    }

    doCheckout() {
        if(this.state.token.length === 0) {
            return;
        }
        var data = {
            Token: this.state.token
        }
        this.props.onComplete(data);
    }

    render() {
        var guest = this.props.guest;

        return (
            <div className='checkout-completed'>
                <div className='checkout-completed__title' style={{height: 40, lineHeight: '40px'}}>
                    Enter Client CanPay Token
                </div>
                <div>
                    <div className="checkout-input">
                        <input
                            style={{
                                position: 'absolute', top: 0, left: 0, width: 140
                            }}
                            type="text"
                            onChange={e => this.setState({ token: e.target.value })}
                        />
                    </div>
                    
                </div>
                <div className='row' style={{margin:0}}>
                    <div
                        style={{
                            display: 'block', left: 40, width: 120, margin: '0 auto', marginBottom: 10, marginTop: 10,
                        }}
                        className={'btn-red'}
                        onClick={this.props.onCancel}>
                        Cancel
                    </div>
                    <div
                        style={{
                            display: 'block', right: 40, width: 120, margin: '0 auto', marginBottom: 10,  marginTop: 10,
                        }}
                        className={'btn-green'}
                        onClick={this.doCheckout}>
                        CHECKOUT
                    </div>
                    
                </div>
            </div>
        );
    }
}

export default CanPayCheckout;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/electronic/CanPayCheckout.react.jsx